import { postGooglePass } from "api/IamApi/entities/ezpay";
import imageSrc from "assets/add_to_google_wallet_button.svg";
import { useEffect, useState } from "react";
import { IBiller, IImageResourcesProperties } from "types/biller";

export interface IGoogleWalletButtonProps {
  biller: IBiller;
  itemNumber?: string;
  barcodeText: string;
  realm: string;
  language: string;
  payableItemTypeLabel: string;
  serviceFee: number;
  quantity?: number;
  amount?: number;
  location?: string;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const GoogleWalletButton = (props: IGoogleWalletButtonProps) => {
  const { biller, barcodeText, realm, itemNumber, language, payableItemTypeLabel, serviceFee, quantity, amount, location } = props;
  const [googlePassLink, setGooglePassLink] = useState("#");
  const imageResources = biller?.properties?.find(element => element.name === "ImageResources")?.properties as IImageResourcesProperties;

  useEffect(() => {
    const googlePassRequest = {
      billerName: biller.billerName,
      itemNumber: itemNumber ?? "",
      logoUrl: imageResources?.logoURL,
      barcode: barcodeText,
      modifiedBy: "ezPay",
      language: language,
      payableItemTypeLabel: payableItemTypeLabel,
      serviceFee: serviceFee,
      ...(quantity != null && quantity > 0 ? { quantity } : {}),
      ...(amount != null ? { amount } : {}),
      ...(location ? { location } : {}),
    };
    const createGooglePassLink = () => {
      postGooglePass(biller.clientId, googlePassRequest, realm)
        .then((res) => {
          if (res.data.link.length !== 0) {
            setGooglePassLink(res.data.link);
          } else {
            console.log("Could not fetch gooogle pass.");
          }
        }).catch((error) => {
          console.log("Could not fetch gooogle pass.");
        })
    };

    // call the function
    createGooglePassLink()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    itemNumber,
    barcodeText,
    biller.billerName,
    language,
    imageResources?.logoURL,
    biller.clientId,
    realm,
    amount,
    location
  ]);

  return (
    <div title="google button">
      {googlePassLink !== "#" && (
        <a href={googlePassLink} target="_blank" rel="noopener noreferrer">
          <img
            className="add-to-google-wallet-button"
            src={imageSrc}
            alt="Add to Google Wallet"
          />
        </a>
      )}
    </div>
  );
};
